// extracted by mini-css-extract-plugin
export var active = "_1x-7";
export var backButton = "_1x-6";
export var clone = "_1x-c";
export var collapseBar = "_1x-g";
export var collapseMode = "_1x-i";
export var dragHandle = "_1x-a";
export var dropdownIcon = "_1x-e";
export var hidden = "_1x-o";
export var iconContainer = "_1x-l";
export var iconSwapper = "_1x-n";
export var navItem = "_1x-4";
export var navItemIcon = "_1x-d";
export var navProfile = "_1x-5";
export var notificationDot = "_1x-m";
export var optionsContainer = "_1x-f";
export var primaryNav = "_1x-0";
export var primaryTab = "_1x-j";
export var secondaryNav = "_1x-1";
export var selected = "_1x-k";
export var settingsNav = "_1x-2";
export var settingsNavItems = "_1x-3";
export var show = "_1x-b";
export var sideNav = "_1x-h";
export var teamItem = "_1x-8";
export var userProfileItem = "_1x-9";